import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StatusEnum } from "../models/SubmissionStatusData";
import * as SubmissionStatusEnum from "../models/SubmissionStatus";
import classes from './StatusInfo.module.css'


const StatusInfo = ({ index, status, dropClass, submittedDate, assessmentDueDate, questionNum, questionComplated }) => {

    const [currentStatus, setCurreneSatatus] = useState()
    const texts = useSelector(state => state.translate.texts);

    useEffect(() => {
        let findStatus = StatusEnum[status]
        if (!findStatus) {
            // check if submitted aftae dueDate 
            if (submittedDate > assessmentDueDate)
                setCurreneSatatus(StatusEnum[SubmissionStatusEnum.late])
            setCurreneSatatus(StatusEnum[SubmissionStatusEnum.started])
        }
        else
            if (findStatus === SubmissionStatusEnum.started && submittedDate > assessmentDueDate)
                setCurreneSatatus(StatusEnum[SubmissionStatusEnum.late])
            else
                setCurreneSatatus(findStatus)

    }, [status])


    return (
        <>
            {currentStatus && <div className={`${classes.StatusInfoContainer} ${dropClass}`} style={{ borderColor: currentStatus.color, backgroundColor: currentStatus.color, top: (25 * index) + 15 + 'px' }}>
                {!questionNum ?
                    <div className={classes.CurrentStep}>{texts[currentStatus.text]} </div>
                    :
                    <div className={classes.CurrentStep}>
                        <p className={classes.QuestionNum}>{questionNum}/</p>
                        <p className={classes.QuestionComplated}>{questionComplated}</p>
                    </div>
                }
                {currentStatus.icon && <img className={classes.CurrentStep} src={currentStatus.icon} />}
            </div>}
        </>
    )

}

export default StatusInfo;